// tslint:disable
export var AccountLocationPurposeType;
(function (AccountLocationPurposeType) {
    // UNKN
    AccountLocationPurposeType[AccountLocationPurposeType["UNKN"] = 0] = "UNKN";
    // HDQTR
    AccountLocationPurposeType[AccountLocationPurposeType["HDQTR"] = 1] = "HDQTR";
    // SALE
    AccountLocationPurposeType[AccountLocationPurposeType["SALE"] = 2] = "SALE";
    // HOME
    AccountLocationPurposeType[AccountLocationPurposeType["HOME"] = 3] = "HOME";
    // WORK
    AccountLocationPurposeType[AccountLocationPurposeType["WORK"] = 4] = "WORK";
    // SEAS
    AccountLocationPurposeType[AccountLocationPurposeType["SEAS"] = 5] = "SEAS";
    // MAIL
    AccountLocationPurposeType[AccountLocationPurposeType["MAIL"] = 6] = "MAIL";
    // BILL
    AccountLocationPurposeType[AccountLocationPurposeType["BILL"] = 7] = "BILL";
    // SHIP
    AccountLocationPurposeType[AccountLocationPurposeType["SHIP"] = 8] = "SHIP";
})(AccountLocationPurposeType || (AccountLocationPurposeType = {}));
//# sourceMappingURL=AccountLocationPurposeType.js.map